import { useMemo } from 'react'
import humanizeGasVolume from '../../utils/humanizeGasVolume'

export default function GasVolume({ children, prefix, postfix, ...props }) {
  const { value, dimension } = useMemo(() => {
    return humanizeGasVolume(children)
  }, [children])

  return <span {...props} >
    { prefix }
    { value }
    <small className={ 'tiny' }>{ dimension }{ postfix }</small>
  </span>
}
